import { registerLocaleData } from '@angular/common';
import {
  enableProdMode,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  BrowserModule,
  bootstrapApplication
} from '@angular/platform-browser';

import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeHu from '@angular/common/locales/hu';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { providePayeeDate } from 'src/app/shared/date/provide-payee-date';
import { providePayeeDialog } from 'src/app/shared/dialog/provide-payee-dialog';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { HttpErrorInterceptor } from './app/interceptor/http-error/http-error.interceptor';
import { environment } from './environments/environment';
import { CustomMissingTranslationHandler } from './app/shared/translate/custom-missing-translation-handler';

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

registerLocaleData(localeHu, 'hu');

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    ...providePayeeDialog(),
    importProvidersFrom(
      AppRoutingModule,
      BrowserModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader,
          deps: [HttpClient],
        },
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useFactory: () => new CustomMissingTranslationHandler(),
          deps: [],
        },
        extend: true,
      }),
    ),
    ...providePayeeDate(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err: unknown) => console.error(err));
